// extracted by mini-css-extract-plugin
module.exports = {"shopLogo":"ProductCollections_shopLogo__eqp5Q","collections":"ProductCollections_collections__3mVT4","checkbox":"ProductCollections_checkbox__2hjHU"};